{
  "VALIDATION_FAILED": "The submitted data is not valid",
  "PHONE_TAKEN": "This phone number belongs to another customer",
  "CUSTOMERS_UNAVAILABLE": "The number could not be verified with the Customers system. Nothing was saved. Try again",
  "CUSTOMER_PHONE_REFUSED": "Customers refused the phone change, the edit was not saved",
  "DOCUMENT_TAKEN": "This document belongs to another customer",
  "CATEGORY_IN_USE": "This category is assigned to customers and cannot be deleted",
  "USERNAME_TAKEN": "This username is already in use",
  "NO_PLATFORM_ACCESS": "You do not have access to this platform",
  "UA_UNAVAILABLE": "Unified Access could not be reached. Try again shortly.",
  "INTEGRATION_UNAUTHORIZED": "Invalid integration credentials",
  "UNAUTHENTICATED": "You need to sign in",
  "INVALID_CREDENTIALS": "Invalid email or password",
  "FORBIDDEN": "You do not have permission for this action",
  "NOT_FOUND": "The requested item was not found",
  "CONFLICT": "Conflicting data. Reload the current data.",
  "UNIQUE_VIOLATION": "This value is already in use",
  "FOREIGN_KEY_VIOLATION": "This item is referenced elsewhere and cannot be deleted",
  "RATE_LIMITED": "Too many attempts. Try again shortly.",
  "IDEMPOTENCY_KEY_REUSED": "This request number was already used for another operation",
  "REQUEST_IN_PROGRESS": "This request is still being processed",
  "PAYLOAD_TOO_LARGE": "The submitted data exceeds the maximum size",
  "UNPROCESSABLE": "The request could not be processed. Check the submitted data.",
  "INTERNAL_ERROR": "The operation could not be completed. Try again or contact your administrator.",
  "SERVICE_UNAVAILABLE": "The service is unavailable right now. Try again shortly.",
  "network": "Could not reach the server. Check your connection and try again.",
  "timeout": "We could not confirm this finished. Check the current state before trying again.",
  "AMOUNT_INVALID": "Enter an amount greater than zero",
  "AMOUNT_DECIMALS_EXCEEDED": "At most five decimal places are allowed.",
  "CURRENCY_CODE_TAKEN": "This currency code is used by another currency",
  "CURRENCY_INACTIVE": "This currency is inactive and cannot be used for a new deposit",
  "CURRENCY_IN_USE": "The code cannot change once a deposit uses this currency",
  "TABLET_NOT_CONFIGURED": "The tablet service is not configured on the server. Contact the administrator.",
  "TABLET_UNAVAILABLE": "Could not reach the tablet service. Try again.",
  "TABLET_NOT_AVAILABLE": "This tablet is not available in this branch.",
  "TABLET_BUSY": "This tablet is busy with another operation",
  "TABLET_REQUEST_INVALID": "The tablet service refused the operation details. Check the entered data and try again.",
  "TABLET_TASK_CLOSED": "This step on the tablet has ended",
  "TABLET_TASK_NOT_SUBMITTED": "The customer has not finished on the tablet yet",
  "TABLET_TASK_KIND_MISMATCH": "The tablet step does not match this operation",
  "SIGNATURE_REQUIRED": "The signature is required",
  "FILE_TYPE_NOT_ALLOWED": "This file type is not allowed",
  "FILE_TOO_LARGE": "The file is larger than allowed",
  "DEPOSIT_NOT_DRAFT": "This deposit was already confirmed or discarded",
  "DEPOSIT_DRAFT_NOT_OWNER": "This draft belongs to another employee",
  "DEPOSIT_CUSTOMER_NOT_PRESENT": "The customer is marked as not present for this deposit, so nothing can be sent to the tablet",
  "DEPOSIT_REFERENCE_UNKNOWN": "Unknown reference number",
  "DEPOSIT_NOT_IN_CUSTODY": "This deposit is not in our custody",
  "DEPOSIT_OTHER_BRANCH": "This deposit is held in another branch",
  "DEPOSIT_BRANCH_NOT_ALLOWED": "You have no access to this deposit's branch",
  "DEPOSIT_REFERRAL_PENDING": "This deposit is awaiting supervisor review",
  "DEPOSIT_REFERRAL_NOT_PENDING": "This referral was already reviewed",
  "DEPOSIT_FIELD_NOT_EDITABLE": "This field cannot be edited in the deposit's current state",
  "DEPOSIT_NO_CHANGES": "No field was changed",
  "MESSAGE_NOT_RESENDABLE": "This message cannot be resent",
  "PHONE_REQUIRED": "The phone number is required",
  "PHONE_INVALID": "The phone number is not valid",
  "PHONE_NOT_MOBILE": "Landline numbers are not allowed. Enter a mobile number",
  "PHONE_COUNTRY_NOT_ALLOWED": "Numbers from this country are not accepted",
  "PHONE_VERIFICATION_REQUIRED": "Verify the phone number before saving",
  "PHONE_VERIFICATION_INVALID": "The code has expired. Request a new code",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "The phone verification expired. Verify again",
  "OTP_INVALID": "The code is incorrect",
  "OTP_EXPIRED": "The code has expired. Request a new code",
  "OTP_ATTEMPTS_EXCEEDED": "Too many wrong attempts. Request a new code",
  "OTP_RESEND_TOO_SOON": "The code cannot be resent yet",
  "OTP_SEND_LIMIT": "Too many codes were sent to this number",
  "OTP_SEND_FAILED": "The verification code could not be sent by WhatsApp. Nothing was saved. Try again, or an administrator can turn verification off in the settings",
  "OTP_ALREADY_VERIFIED": "The phone number has been verified",
  "OTP_ALREADY_CONSUMED": "The code has expired. Request a new code",
  "OTP_BINDING_MISMATCH": "The code has expired. Request a new code",
  "OTP_NOT_VERIFIED": "Verify the phone number before saving",
  "OTP_CONSUME_WINDOW_PASSED": "The code has expired. Request a new code",
  "IDEMPOTENCY_CONFLICT": "This request number was already used for another operation",
  "PHONE_TAKEN_BY": "This phone number belongs to another customer: {{name}}"
}
